import { CURRENCY_CODE_TO_SYMBOL } from '@namespace/helpers';

export const getCurrencySign = (code: string | undefined | null): string => {
  if (!code) {
    return '';
  }

  const upperCaseCode =
    code.toLocaleUpperCase() as keyof typeof CURRENCY_CODE_TO_SYMBOL;

  return CURRENCY_CODE_TO_SYMBOL[upperCaseCode] || '';
};
